
import {
  Box,
  Fab
} from '@mui/material';
import {
  Phone
} from '@mui/icons-material';

export default function FloatingButtons() {
  return (
    <>
      {/* Floating Dial Button */}
      <Fab
        component="a"
        href="tel:+918758485159"
        sx={{
          position: 'fixed',
          bottom: 96,
          left: 24,
          bgcolor: '#2196F3',
          '&:hover': { bgcolor: '#1976D2', transform: 'scale(1.1)' },
          transition: 'transform 0.2s',
          zIndex: 40
        }}
      >
        <Phone sx={{ color: 'white' }} />
      </Fab>

      {/* Floating WhatsApp Button */}
      <Fab
        component="a"
        href="https://wa.me/918758485159?text=Hello%20SHREE%20CONSULTANCY!%20I%20would%20like%20to%20inquire%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'fixed',
          bottom: 24,
          left: 24,
          bgcolor: '#25D366',
          '&:hover': { bgcolor: '#128C7E', transform: 'scale(1.1)' },
          transition: 'transform 0.2s',
          zIndex: 40
        }}
      >
        <Box
          component="svg"
          viewBox="0 0 32 32"
          sx={{ width: 32, height: 32, fill: 'white' }}
        >
          <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 8.15-2.137c2.366 1.338 5.047 2.137 7.85 2.137 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.297c-2.477 0-4.902-0.687-7.013-1.981l-0.506-0.294-5.169 1.356 1.381-5.094-0.325-0.525c-1.431-2.269-2.194-4.906-2.194-7.559 0-7.85 6.384-14.234 14.234-14.234s14.234 6.384 14.234 14.234-6.384 14.097-14.234 14.097zM21.766 18.413c-0.287-0.144-1.7-0.844-1.969-0.937-0.262-0.094-0.456-0.144-0.65 0.144s-0.744 0.937-0.913 1.131c-0.169 0.194-0.331 0.219-0.619 0.075s-1.206-0.444-2.294-1.413c-0.85-0.756-1.419-1.694-1.588-1.981s-0.019-0.444 0.125-0.588c0.131-0.131 0.287-0.338 0.431-0.506s0.194-0.287 0.287-0.481c0.094-0.194 0.050-0.363-0.025-0.506s-0.65-1.569-0.894-2.144c-0.238-0.556-0.481-0.481-0.65-0.488-0.169-0.012-0.363-0.012-0.556-0.012s-0.506 0.075-0.769 0.363c-0.262 0.287-1.006 0.981-1.006 2.394s1.031 2.781 1.175 2.975c0.144 0.194 2.012 3.075 4.875 4.306 0.681 0.294 1.213 0.469 1.625 0.6 0.688 0.219 1.313 0.188 1.806 0.113 0.556-0.081 1.7-0.694 1.938-1.363s0.238-1.244 0.169-1.363c-0.075-0.113-0.275-0.188-0.563-0.331z" />
        </Box>
      </Fab>
    </>
  );
}